import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { setLoader } from '../../../Redux/features/LoaderSlice';
import axiosInstance from 'Utils/Interceptor';
import CustomModal from 'Components/Modal/CustomModal';

const UploadImageFile = ({ setFileURL }) => {
  const [fileName, setFileName] = useState(null);
  const fileInputRef = useRef(null);
  const [filePreviewURL, setFilePreviewURL] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFileName(e.target.files[0].name);
      const file = e.target.files[0];
      // Set file preview URL
      const previewURL = URL.createObjectURL(file);
      setFilePreviewURL(previewURL);
      uploadImage(e.target.files[0]);
    }
  };

  const uploadImage = async (imageFile) => {
    const formData = new FormData();
    formData.append('file', imageFile);
    formData.append('type', 'prescription');
    dispatch(setLoader(true));
    try {
      const response = await axiosInstance.post(
        '/api/user/uploadimage',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      setFileURL(response?.data?.data);
    } catch (error) {
      // Handle the error here if needed
      console.error(error);
    } finally {
      dispatch(setLoader(false));
    }
  };

  const openModal = async() => {
    if (filePreviewURL) {
      // Attempt to fetch the file type if not already known
      if (fileName?.endsWith('.pdf') || filePreviewURL.includes('.pdf')) {
        const link = document.createElement('a');
        link.href = filePreviewURL;
        link.download = fileName || 'download.pdf'; // Fallback filename
        link.click(); // Trigger the download
      } else if (
        fileName?.match(/\.(jpg|jpeg|png)$/i) ||
        filePreviewURL.includes('image')
      ) {
        setModalOpen(true); // Open images in a new tab
      } else {
        alert('Unsupported file type for viewing.');
      }
    }
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const clearFile = () => {
    setFileName(null);
    setFileURL(null); // Clear the uploaded file URL
    fileInputRef.current.value = ''; // Reset the file input
  };

  const viewFile = () => {
    if (filePreviewURL) {
      window.open(filePreviewURL, '_blank'); // Open in a new tab
    }
  };

  return (
    <div className="image-upload">
      <div className="form-group">
        <button
          type="button"
          className="btn btn-md"
          onClick={() => fileInputRef.current.click()}
        >
          <span>Upload Prescription</span>
        </button>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/jpeg,image/png,application/pdf"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      {fileName && (
        <div className="prescription-upload-wrapper">
          <div className="prescription-text">{fileName}</div>
          <div className="prescription-view">
            <button
              onClick={openModal}
              className="btn btn-small"
            >
              <span>View</span>
            </button>

            <button
              onClick={clearFile}
              type="button"
              className="btn-close"
              aria-label="Close"
            ></button>
          </div>
        </div>
      )}
      <p className="accepted-files">Accepted file types: JPEG, PNG, PDF</p>
      {/* Modal for Preview */}
      {isModalOpen && (
        <CustomModal
          onClose={closeModal}
          removeHeader={true}
          show={isModalOpen}
          size="full"
        >
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000
            }}
            onClick={closeModal}
          >
            <div
              style={{
                background: '#fff',
                padding: '20px',
                borderRadius: '8px',
                width: '80%',
                maxWidth: '500px',
                position: 'relative'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={closeModal}
                className="btn-close"
                aria-label="Close"
              ></button>
              {filePreviewURL.endsWith('.pdf') ? (
                window.open(filePreviewURL, '_blank') // Open in a new tab
              ) : (
                <img
                  src={filePreviewURL}
                  alt="Preview"
                  style={{ width: '100%', height: 'auto' }}
                />
              )}
            </div>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default UploadImageFile;
